import { DownOutlined, MenuOutlined } from '@ant-design/icons';
import { Menu, Space } from 'antd';
import Dropdown from 'antd/es/dropdown/dropdown';
import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { useIsMobile } from 'src/app/providers/AppProvider';
import { isMobileDevice } from 'src/common/utils/is-mobile-device';
import { Icon, IconType } from 'src/components/base/Icon';
import { getCommonRoutePath } from 'src/helpers/Helpers';
import { useAppSelector } from 'src/hooks/store';
import './styles.scss';
var ICON_TYPE_MAPPING = {
    home: IconType.TapHome,
    users: IconType.TapUser,
    posts: IconType.Picture,
    faqs: IconType.Help,
    chats: IconType.TapUsers,
    liveStreams: IconType.Camera,
    forum: IconType.Messages,
};
var routes = [
    { path: '/interaction', tab: '', name: '' },
    { path: '/chat-to-us', tab: 'users', name: 'Ambassadors' },
    { path: '/group-chats', tab: 'chats', name: 'Group Chats' },
    { path: '/posts', tab: 'posts', name: 'Content' },
    { path: '/faq', tab: 'faqs', name: 'FAQs' },
    { path: '/live-streams', tab: 'liveStreams', name: 'Live Streams' },
    { path: '/forum', tab: 'forum', name: 'Forum' },
    { path: '/sign-in', tab: 'login', name: '' },
];
function getActiveTab(path) {
    // Find the first route that matches the current page
    var matchingRoute = routes.find(function (route) { return path.includes(route.path); });
    // If a matching route is found, return its tab and name
    if (matchingRoute) {
        return { activeTab: matchingRoute.tab, tabName: matchingRoute.name };
    }
    // Fallback for '/interaction' path or when no other routes match
    if (!path.includes('/interaction')) {
        return { activeTab: 'home', tabName: 'Home' };
    }
    // Default return when '/interaction' is in the path but no specific tab is matched
    return { activeTab: '', tabName: '' };
}
var createTab = function (key, to, title) {
    var TabIcon = ICON_TYPE_MAPPING[key] || IconType.TapHome;
    var commonRoutePath = getCommonRoutePath();
    return {
        key: key,
        icon: React.createElement(Icon, { className: "tab-img", type: TabIcon }),
        label: React.createElement(NavLink, { to: "".concat(commonRoutePath).concat(to) }, title),
        title: title,
    };
};
var triggetVariant = ['click'];
export var NavigationTabs = function () {
    var main = useAppSelector(function (state) { return state.main; });
    var isMobile = useIsMobile();
    var _a = getActiveTab(window.location.href), activeTab = _a.activeTab, tabName = _a.tabName;
    var isCarousel = window.location.href.includes('carousel');
    var isStreamPage = window.location.href.includes('/live-streams/');
    var navigationItems = useMemo(function () {
        var tabs = [createTab('home', '/', 'Home')];
        if (!isCarousel) {
            if (main.showUsers)
                tabs.push(createTab('users', '/chat-to-us', 'Ambassadors'));
            if (main.showPosts)
                tabs.push(createTab('posts', '/posts', 'Content'));
            if (main.showFaqs)
                tabs.push(createTab('faqs', '/faq', 'FAQs'));
            if (main.showGroupChats)
                tabs.push(createTab('chats', '/group-chats', 'Group Chats'));
            if (main.showLiveStreams)
                tabs.push(createTab('liveStreams', '/live-streams', 'Streams'));
            if (main.showForum)
                tabs.push(createTab('forum', '/forum', 'Forum'));
        }
        return tabs;
    }, [main, isCarousel]);
    return isMobile && isMobileDevice() ? (React.createElement(Dropdown, { trigger: triggetVariant, destroyPopupOnHide: true, menu: {
            items: navigationItems,
            activeKey: activeTab,
            rootClassName: 'page-nav',
        } },
        React.createElement(Space, { className: "flex items-center text-18" }, isStreamPage ? (React.createElement(MenuOutlined, null)) : (React.createElement(React.Fragment, null,
            tabName || 'Home',
            React.createElement(DownOutlined, { className: "size-3 translate-y-0.5" })))))) : (React.createElement(Menu, { rootClassName: "page-nav flex-grow w-0", mode: "horizontal", triggerSubMenuAction: "click", items: navigationItems, activeKey: activeTab }));
};
